"use client";

import { Award, Download, Shield, Sparkles, Syringe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Compliance() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const standards = [{
    icon: Shield,
    title: "法規合規性",
    description: "我們確保所有進口醫療設備嚴格遵守國際法規標準，包括全球安全的CE、FDA與ISO認證。"
  }, {
    icon: Syringe,
    title: "臨床評估",
    description: "每一項產品都經過我們專家團隊的嚴格臨床評估，以驗證對醫療提供者的療效、安全性與長期價值。"
  }, {
    icon: Sparkles,
    title: "品質保證",
    description: "我們與維持優質生產標準的製造商建立獨家合作關係，確保每一種設備都符合醫療卓越的最高基準。"
  }, {
    icon: Award,
    title: "全球配銷標準",
    description: "我們的物流與配銷網絡遵循嚴格的醫療級處理協議，確保產品從製造商到終端使用者的完整性。"
  }];
  const certifications = ["ISO 13485 認證", "CE標誌符合", "FDA 註冊合作夥伴", "全球品質保證", "臨床驗證"];
  return <section data-section-id="32" id="compliancecertifications" className="py-24 md:py-32 lg:py-40 px-6 md:px-10 font-default bg-background text-foreground">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`text-center mb-20 md:mb-28 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-sans text-xs md:text-sm tracking-widest uppercase mb-8 text-teal-600">
            03 / 合規性與品質
          </p>
          <h2 className="font-default text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.95] tracking-tight text-slate-900">
            全球
            <br />
            <span className="text-blue-700">標準。</span>
          </h2>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 relative">
          {standards.map((item, i) => {
          const Icon = item.icon;
          return <div data-index={i} key={i} className={`relative p-8 md:p-10 transition-all duration-700 ease-out rounded-lg shadow-md bg-white ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${i % 2 === 1 ? "sm:border-l" : ""} ${i >= 2 ? "sm:border-t lg:border-t-0" : ""} ${i > 0 ? "lg:border-l border-t sm:border-t-0" : ""}`} style={{
            transitionDelay: `${i * 120}ms`,
            borderColor: "hsl(178 15% 89%)"
          }}>
                <Icon className="w-16 h-16 mb-8 text-teal-600" strokeWidth={1} />
                <h3 className="font-default text-2xl font-semibold leading-tight mb-4 text-slate-900">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed font-default text-slate-600">
                  {item.description}
                </p>
              </div>;
        })}
        </div>

        {}
        <div ref={footerRef} className={`mt-24 md:mt-32 transition-all duration-700 ease-out ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 mb-16 md:mb-20">
            {certifications.map((cert, i) => <span data-index={i} key={i} className="font-default text-xs tracking-widest uppercase text-slate-500">
                {cert}
              </span>)}
          </div>

          {}
          <div className="flex justify-center">
            <Button variant="outline" size="lg" className="font-default text-xs tracking-widest uppercase bg-blue-600 text-white border-2 border-blue-600 px-8 py-6 h-auto transition-colors duration-300 hover:bg-blue-700 rounded-lg">
              <Download className="w-4 h-4 mr-2" strokeWidth={1.5} />
              下載合規性檔案 (PDF)
              <span aria-hidden="true">→</span>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}